'use client'

import { useTexts } from '@/contexts/LanguageContext'
import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import PageHeader from '../../components/PageHeader'
import { PAGE_CONTAINER_CLASS } from '../../utils'
import PrivacyCards from './PrivacyCards'
import SubprocessorsTable from './SubprocessorsTable'

export default function Subprocessors() {
  const { SUBPROCESSORS } = useTexts().PUBLIC_TRUST_CENTER
  const { subprocessors } = useTrustCenterConfig()
  return (
    <div className={PAGE_CONTAINER_CLASS}>
      <PageHeader title={SUBPROCESSORS.TITLE} subtitle={SUBPROCESSORS.SUBTITLE} />
      <SubprocessorsTable subprocessors={subprocessors} />
      <PrivacyCards />
    </div>
  )
}
